<template>
  <FAQList :config="config" />
</template>

<script>
import FAQList from "../../components/FAQList/FAQList.vue";

export default {
  name: "app",
  components: {
    FAQList
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config)
    };
  }
};
</script>
